import { useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

const Guests = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Guests.title",
            defaultMessage: "Guests"
        }),
        content: intl.formatMessage(
            {
                id: "ConfluencePricingPage.modalContents.Guests.content",
                defaultMessage:
                    "<p>For each paid user, admins can add up to five guests for no additional cost or licenses.</p> <p>There are no limits to how many spaces you can share or how many guests you can have in each space. However, each guest is limited to a single space.</p>"
            },
            { ...DEFAULT_VALUES }
        ),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Guests.altText",
            defaultMessage: "External collaboration"
        }),
        imageCaption: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.Guests.imageCaption",
            defaultMessage:
                "Here’s what a guest comment looks like in external collaboration in Confluence."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            {messages.content}
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Guest_markers_in_product.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.imageCaption}</p>
        </div>
    );
};

export default Guests;
